// Heat Flux Density units with conversion factors to W/m² (Watt per Square Meter)
export const heatFluxDensityUnits = [
  { id: 'watt-per-square-meter', name: 'Watt per Square Meter', symbol: 'W/m²', plural: 'Watts per Square Meter', factor: 1 },
  { id: 'watt-per-square-centimeter', name: 'Watt per Square Centimeter', symbol: 'W/cm²', plural: 'Watts per Square Centimeter', factor: 10000 },
  { id: 'watt-per-square-inch', name: 'Watt per Square Inch', symbol: 'W/in²', plural: 'Watts per Square Inch', factor: 1550.0031 },
  { id: 'kilowatt-per-square-meter', name: 'Kilowatt per Square Meter', symbol: 'kW/m²', plural: 'Kilowatts per Square Meter', factor: 1000 },
  { id: 'calorie-per-second-square-centimeter', name: 'Calorie per Second Square Centimeter', symbol: 'cal/(s·cm²)', plural: 'Calories per Second Square Centimeter', factor: 41868 },
  { id: 'kilocalorie-per-hour-square-meter', name: 'Kilocalorie per Hour Square Meter', symbol: 'kcal/(h·m²)', plural: 'Kilocalories per Hour Square Meter', factor: 1.163 },
  { id: 'btu-per-hour-square-foot', name: 'BTU per Hour Square Foot', symbol: 'BTU/(h·ft²)', plural: 'BTU per Hour Square Foot', factor: 3.15459 },
  { id: 'btu-per-second-square-foot', name: 'BTU per Second Square Foot', symbol: 'BTU/(s·ft²)', plural: 'BTU per Second Square Foot', factor: 11356.5 },
  { id: 'btu-per-hour-square-inch', name: 'BTU per Hour Square Inch', symbol: 'BTU/(h·in²)', plural: 'BTU per Hour Square Inch', factor: 454.25 },
  { id: 'horsepower-per-square-foot', name: 'Horsepower per Square Foot', symbol: 'hp/ft²', plural: 'Horsepower per Square Foot', factor: 8026.65 },
];

export const popularHeatFluxDensityConversions = [
  { from: 'watt-per-square-meter', to: 'btu-per-hour-square-foot' },
  { from: 'btu-per-hour-square-foot', to: 'watt-per-square-meter' },
  { from: 'watt-per-square-meter', to: 'kilowatt-per-square-meter' },
  { from: 'watt-per-square-centimeter', to: 'watt-per-square-meter' },
  { from: 'calorie-per-second-square-centimeter', to: 'watt-per-square-meter' },
  { from: 'kilocalorie-per-hour-square-meter', to: 'watt-per-square-meter' },
];

export const getUnitById = (id) => heatFluxDensityUnits.find(unit => unit.id === id);

export const convertHeatFluxDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert heat flux density units and learn the conversion formula.`;
};
